import type { AiTool } from '@lyrmo/shared';
import { useCallback } from 'react';
import type { ApiClient } from '../../api/client';
import { useAccountList, type AccountList } from './useAccountList';

/**
 * The writer's own AI tools, for the AI tools menu. `owner` is who's signed in: null for nobody,
 * who has none, and undefined until that's known.
 */
export function useAiTools(
  client: Pick<ApiClient, 'listAiTools'>,
  owner: string | null | undefined,
): AccountList<AiTool> {
  const load = useCallback(() => client.listAiTools(), [client]);
  return useAccountList(load, owner);
}
